import packageJson from '../package.json';

const asBool = (value: string | undefined): boolean => value === 'true';

export interface ConfigState {
    backend: {
        IAM_BASE_URL: string | undefined;
    };
    homeRoute: string | undefined;
    logoutUri: string | undefined;
    postLogoutRedirectUri: string | undefined;
    id: string | undefined;
    enableMockServer: boolean;
    login: {
        authority: string | undefined;
        clientId: string | undefined;
        // oauthScope: string[];
        mockAuthorization: boolean;
        mockLocale: string | undefined;
        mockTenant: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
    };
    sentryToken: string | undefined;
    sentryModuleName: string;
    isTestTenantMode: boolean;
    serviceVersion: string;
    serviceEnvironment: string;
}

const {
    location: { host },
} = window;

export const config: ConfigState = {
    backend: {
        IAM_BASE_URL: import.meta.env.VITE_IAM_BASE_URL,
    },
    homeRoute: import.meta.env.VITE_HOME_ROUTE,
    logoutUri: import.meta.env.VITE_LOGOUT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI,
    id: import.meta.env.VITE_ID,
    enableMockServer: import.meta.env.DEV,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
        // oauthScope: ['openid', 'profile', 'email'],
        mockAuthorization: import.meta.env.DEV,
        mockLocale: import.meta.env.VITE_LOGIN_MOCK_LOCALE,
        mockTenant: import.meta.env.VITE_LOGIN_MOCK_TENANT,
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
    },
    sentryToken: import.meta.env.VITE_SENTRY_DSN,
    sentryModuleName: 'userRegistration',
    isTestTenantMode: host === 'test-registration.iam.rio.cloud' || host === '127.0.0.1:9089',
    serviceVersion: packageJson.version,
    serviceEnvironment: import.meta.env.MODE,
};
